import { render, staticRenderFns } from "./TxnSummaryMain.vue?vue&type=template&id=8a037364&scoped=true&"
import script from "./TxnSummaryMain.vue?vue&type=script&lang=ts&"
export * from "./TxnSummaryMain.vue?vue&type=script&lang=ts&"
import style0 from "./TxnSummaryMain.vue?vue&type=style&index=0&id=8a037364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a037364",
  null
  
)

export default component.exports